<template>
    <v-dialog
            v-model="dialog"
            width="500"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                    icon small
                    v-bind="attrs"
                    v-on="on"
            >
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
        </template>

        <v-card>
            <v-card-title>
                Поиск
            </v-card-title>
            <v-card-actions>
                <v-text-field
                        v-model="searchMessage"
                        hide-details
                        class="mr-4"
                        placeholder="Поиск"
                        v-on:keyup.enter="search"
                >
                </v-text-field>
                <v-btn outlined @click="search">
                    Поиск
                </v-btn>
            </v-card-actions>
            <v-card-text>
                <v-list
                        class="overflow-y-auto"
                        max-height="calc(95vh - 210px)"
                >
                    <v-list-item
                            v-for="foundMessage in foundMessageList"
                            :key="'dict_' + foundMessage.id"
                            v-on:click="openSelectedMessage(foundMessage)"
                    >
                        <v-list-item-content>
                            <v-list-item-title v-html="foundMessage.body"></v-list-item-title>
                            <v-list-item-subtitle>{{foundMessage.createdAt | formatDate}}</v-list-item-subtitle>
                        </v-list-item-content>

                    </v-list-item>
                </v-list>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">
                    {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "ChatSearch",
        props:{
            searchSelectMessageFnc: Function
        },
        computed: {
            foundMessageList(){
                return this.$store.getters.foundMessageList
            }
        },
        data(){
            return {
                dialog: false,
                searchMessage: null
            }
        },
        methods: {
            search(){
               if(this.searchMessage){
                   this.$store.dispatch('searchChatMessage', this.searchMessage)
               }
            },
            openSelectedMessage(foundMessage){
                this.dialog = false
                this.searchMessage = null

                this.$store.dispatch('clearSearchChatMessage').then(() => {
                    this.searchSelectMessageFnc(foundMessage)
                })
            }
        }
    }
</script>

<style scoped>

</style>